// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ReimbursementDetails, {getDefaultState as getReimbursementDetailsDefaultState} from './reimbursement-details';
import t from 'tcomb';

const AuditClaim = t.struct({
    claimNumber: t.String,
    claimType: KeyValuePair,
    creditMemoNumber: t.String,
    isSystemSelected: t.Bool,
    issueDate: t.maybe(t.Number),
    pin: t.String,
    reimbursementDetails: ReimbursementDetails,
    responsibleAccount: t.String,
    subClaimType: KeyValuePair,
    updatedOn: t.maybe(t.Number),
    warrantyType: KeyValuePair,
    workOrder: t.String
}, {
    name: 'AuditClaim',
    strict: true
});

export const getDefaultState = () => new AuditClaim({
    claimNumber: '',
    claimType: getKeyValuePairDefaultState(),
    creditMemoNumber: '',
    isSystemSelected: false,
    issueDate: null,
    pin: '',
    reimbursementDetails: getReimbursementDetailsDefaultState(),
    responsibleAccount: '',
    subClaimType: getKeyValuePairDefaultState(),
    updatedOn: null,
    warrantyType: getKeyValuePairDefaultState(),
    workOrder: ''
});

export default AuditClaim;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-claim.js